import script from "./GaokaoQuestionBank.vue?vue&type=script&setup=true&lang=ts"
export * from "./GaokaoQuestionBank.vue?vue&type=script&setup=true&lang=ts"

import "./GaokaoQuestionBank.vue?vue&type=style&index=0&id=432fb1e8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432fb1e8"]])

export default __exports__